<template>
  <div class="kt-portlet kt-portlet--tabs mt-5">
    <div class="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid my-2">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabbedPortlet'
}
</script>
